import React from 'react';
import PropTypes from 'prop-types';
import HTMLDECODE from '../../utils/htmlDecode';

class InputClaro extends React.Component {
  showLeftIcon = () => {
    let leftIcon;
    if (this.props.leftIcon) leftIcon = `fa fa-${this.props.leftIcon}`;

    return (
      <div className="input-group-addon left__icon">
        <i
          style={{ cursor: 'pointer' }}
          className={leftIcon}
          onClick={this.props.showPassword}
        />
      </div>
    );
  };

  render() {
    const containerStyle = {
      width: '100%',
    };

    const claroVideoBlackStyle = {
      border: '1px solid white',
      borderRadius: '6px',
      padding: '12px',
      width: '100%',
      height: '42px',
      ...(this.props.style && this.props.style),
    };

    let wrapperClass = 'form-group Form__input';
    let spanIconClass = 'input-group-addon error-icon hide';
    const icon = `fa fa-${this.props.icon}`;

    if (this.props.error && this.props.error.length > 0) {
      wrapperClass += 'has-error';
      spanIconClass = 'error-icon';
    }

    return (
      <div className={wrapperClass}>
        <div className="Form__input--div">
          <div className="input-group" style={containerStyle}>
            <label className="control-label">{this.props.labelText}</label>
            <input
              style={claroVideoBlackStyle}
              type="text"
              className={`form-control height-34 ${this.props.labelClassName &&
                this.props.labelClassName}`}
              id="exampleInputAmount"
              placeholder={this.props.placeholderText}
              id={this.props.idElement}
              name={this.props.idElement}
              type={this.props.inputType}
              value={this.props.value}
              onChange={this.props.onChange}
              minLength={this.props.minLength}
              maxLength={this.props.maxLength}
            />
          </div>
          <span className="help-block help-label-error error-wrapper error-invalid">
            {HTMLDECODE(this.props.error)}
          </span>
        </div>
      </div>
    );
  }
}

InputClaro.propTypes = {
  labelTip: PropTypes.string,
  labelClassName: PropTypes.string,
  style: PropTypes.object,
};

export default InputClaro;
